import { Achievement, AchievementType } from '@borg/types';

type CreateAchievement = Omit<Achievement & { type?: AchievementType }, 'id'>;

const BASE_URL = '/v2/me/achievements';

class AchievementsRepository extends Repository<Achievement> {
  getMany(type: AchievementType) {
    return this._getMany({ url: `${BASE_URL}?type=${type}` });
  }

  get(id: number | string) {
    return this._get({ url: `${BASE_URL}/${id}` });
  }

  save(data: Achievement) {
    return this._save({ url: `${BASE_URL}/${data.id}`, data });
  }

  create(data: CreateAchievement) {
    return this._create({ url: BASE_URL, data });
  }

  delete(id: number | string) {
    return this._delete({ url: `${BASE_URL}/${id}` });
  }
}

export const achievementsRepository = new AchievementsRepository();
